import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import Modal from 'components/Modal/Modal';
import { TASK_HEAD_IRO_CELLS } from 'constants/dataSets';
import { TABS_IRO_SEND_QUESTIONARY } from 'constants/general';
import { BUTTON_VARIANT } from 'constants/interfaces';

import ItemsTable from '../ItemsTable/ItemsTable';

import type ISendQuestionary from './interfaces/ISendQuestionary';

import styles from './scss/SendQuestionary.module.scss';

function SendQuestionary({
  open, title, loading, itemsMain,
  activeTab, handleClickTab, handleCancel, handleAddSubmit,
  naceCodeTreeData, onLoadMore, hasMore, loadingItems, control,
  onSelectItem, selectedItems, handleUnSelectAll, handleSelectTemplateItem,
}: ISendQuestionary) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={title || ''}
      className={styles.modalContainer}
      isButtonsVisible={false}
      showLoader={loading}
    >
      <div className={styles.root}>
        <div className={styles.content}>
          <div className={styles.tabs}>
            {TABS_IRO_SEND_QUESTIONARY.map((item) => (
              <Button
                key={[item.id, item.name].join('-')}
                title={t(`materialityAssessment.${item.value}`)}
                variant={BUTTON_VARIANT.ghost}
                onClick={() => handleClickTab(item.id)}
                className={clsx(styles.tab, { [styles.active]: activeTab === item.id })}
              />
            ))}
          </div>
          <div className={styles.tableWrapper}>
            {itemsMain && itemsMain?.length > 0 ? (
              <ItemsTable
                items={itemsMain}
                headCells={TASK_HEAD_IRO_CELLS}
                onLoadMore={onLoadMore}
                hasMore={hasMore}
                isLoadingMore={loadingItems}
                naceCodeTreeData={naceCodeTreeData}
                control={control}
                onSelectItem={onSelectItem}
                selectedItems={selectedItems}
                handleUnSelectAll={handleUnSelectAll}
                handleSelectTemplateItem={handleSelectTemplateItem}
                activeTab={activeTab}
                isInfoTable
              />
            ) : (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyTable', {
                  name: TABS_IRO_SEND_QUESTIONARY.find((tab) => tab.id === activeTab)?.name,
                })}
                checkIcon
              />
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={handleCancel}
          />
          <Button
            title={t('common.send')}
            onClick={handleAddSubmit}
            className={styles.button}
          />
        </div>
      </div>
    </Modal>
  );
}

export default SendQuestionary;
